(function () {
  if (window.ReigningWet && window.ReigningWet.supabase) return;

  window.ReigningWet = window.ReigningWet || {};

  var SUPABASE_URL = 'https://cgvmufhkniuvgqtavrwn.supabase.co';
  var SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_SR70y1YDkrsfvNMrTjmdwA_yIwNFdhS';
  var SDK_URL = 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2/dist/umd/supabase.js';

  function announceReady() {
    document.dispatchEvent(new CustomEvent('reigningwet:supabase-ready'));
  }

  function announceError(error) {
    window.ReigningWet.supabaseError = error;
    document.dispatchEvent(new CustomEvent('reigningwet:supabase-error', { detail: error }));
    if (window.console && console.error) console.error('[ReigningWet] Supabase failed to load:', error);
  }

  function initClient() {
    try {
      if (!window.supabase || typeof window.supabase.createClient !== 'function') {
        throw new Error('Supabase SDK did not load correctly');
      }

      window.ReigningWet.supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
        },
      });

      announceReady();
    } catch (error) {
      announceError(error);
    }
  }

  // Already loaded by another script on this page — just init.
  if (window.supabase && typeof window.supabase.createClient === 'function') {
    initClient();
    return;
  }

  // Another instance of this file already started loading the SDK — wait for it.
  var existingScript = document.querySelector('script[data-rw-supabase-sdk]');
  if (existingScript) {
    existingScript.addEventListener('load', initClient);
    existingScript.addEventListener('error', function () {
      announceError(new Error('Supabase SDK failed to load'));
    });
    return;
  }

  var script = document.createElement('script');
  script.src = SDK_URL;
  script.defer = true;
  script.dataset.rwSupabaseSdk = 'true';
  script.addEventListener('load', initClient);
  script.addEventListener('error', function () {
    announceError(new Error('Supabase SDK failed to load'));
  });
  document.head.appendChild(script);
})();
